// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/canvas/changelogs" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { canvasChangelogs } from "./constants";
import type { ChangelogsResult } from "./types";

export const getCanvasChangelogs = reactQueryFetcherAdapter(
  canvasChangelogs,
  (signal: AbortSignal, id: string, versionId = ""): Promise<ChangelogsResult> => {
    const params = { id, v_id: versionId };

    if (!versionId) {
      delete params.v_id;
    }

    return fetch("/engagement/canvas/changelogs", "GET", params, { signal });
  }
);
